import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {AthleteNextGameModuleTerms} from "./athlete-next-game.module.terms";
import {APP} from "../../../../core/app/consts";

export class AthleteNextGameModuleConfig extends BaseConfig {

  static injectables = [AthleteNextGameModuleTerms];

  constructor(terms: AthleteNextGameModuleTerms) {
    super('athleteNextGameModule', null, terms);

    this.source = APP.ANALYTICS.SOURCES.athleteNextGame;
  }
}
